import { Navigate, useLocation } from "react-router";
import useUserStore from "./utils/Stores/userStore";
import Onboarding from "./components/Onboarding";

import Timer from "./components/Timer";
import SupportText from "./components/Global/SupportText";

type ProtectedRouteProps = {
  children: any;
  allowedRoles?: string[];
};
export const ProtectedRoute = ({
  children,
  allowedRoles,
}: ProtectedRouteProps) => {
  const user = useUserStore((state: any) => state.user);
  const isLogged = useUserStore((state: any) => state.isLogged);
  const fetchUserLoading = useUserStore((state: any) => state.fetchUserLoading);

  const location = useLocation();

  if (allowedRoles?.length > 0 && user) {
    const userRights = user?.type_of_user;
    const hasRequiredRights = allowedRoles.some((requiredRight) =>
      userRights?.includes(requiredRight)
    );

    if (!hasRequiredRights) {
      return <Navigate to="/404" />;
    }
  }

  if (!isLogged)
    return (
      <Navigate
        to={{
          pathname: `/login`,
        }}
        state={{ from: location.pathname }}
      />
    );

  if (
    user &&
    (!user?.selectedWorkSpace || user?.workSpaceOwner) &&
    (!user.subscription || user.subscription?.subscribed === false) &&
    !fetchUserLoading
  ) {
    return <Onboarding />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        {children}
        <Timer />
      </div>
      <SupportText />
    </div>
  );
};
